import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { LightProgramBundleInfoDto } from "@modules/programBundle/api/programBundleDto"
import { LightProgramBundleInfo } from "@modules/programBundle/entities/programBundleEntity"
import { convertLightProgramInfoFromDto, LightProgramInfoDto } from "@modules/programs/services/programDto"
import { PromoCode } from "@modules/promoCode/types/promoCodeTypes"
import { z } from "zod"

export enum PromoCodeArchivedStatus {
  DELETED = "DELETED",
  MAX_ATTENDEES = "MAX_ATTENDEES",
  EXPIRED = "EXPIRED",
}

export type PromoCodeDto = {
  id: string
  title: string
  code: string
  type: CouponType
  value: number
  createdAt: string
  expirationDate?: string
  durationInMonths?: number
  maxAttendees?: number
  onlyNewCustomer: boolean
  archived: boolean
  archivedStatus?: PromoCodeArchivedStatus
  programs?: LightProgramInfoDto[]
  programBundles?: LightProgramBundleInfoDto[]
}

export const convertPromoCodeFromDto = (dto: PromoCodeDto): PromoCode => {
  return {
    ...dto,
    programs: dto.programs?.map((program) => convertLightProgramInfoFromDto(program)) ?? [],
    programBundles: dto.programBundles?.map((programBundle) => LightProgramBundleInfo.fromDto(programBundle)) ?? [],
  }
}

export const LightPromoCodeDtoSchema = z.object({
  id: z.string(),
  title: z.string(),
  code: z.string(),
  type: z.nativeEnum(CouponType),
  value: z.number(),
  createdAt: z.string().datetime(),
  duration: z.number().nullable(), // TODO wait back for refacto to durationInMonths
})

export type LightPromoCodeDto = z.infer<typeof LightPromoCodeDtoSchema>
